export default __webpack_public_path__ + "static/media/j3.085da967.JPG";